import React, { useRef } from 'react';
import { HeroSection } from '../components/HeroSection';
import { ShowreelVideo } from '../components/ShowreelVideo';
import { ManifestoSection } from '../components/ManifestoSection';
import { AgencyTagline } from '../components/AgencyTagline';
import { StatementSection } from '../components/StatementSection';
import { ProjectsSection } from '../components/ProjectsSection';
import { OneMoreThing } from '../components/OneMoreThing';
import { WorkFlash } from '../components/WorkFlash';
import { ClosingHero } from '../components/ClosingHero';
import { DroneCompanion } from '../components/DroneCompanion';
import { GlassCrackOverlay } from '../components/GlassCrackOverlay';
import { InteractionShield } from '../components/InteractionShield';
import { DarkSweep } from '../components/DarkSweep';
const MODEL_URL = 'https://ajn1fksl1kjjnow6.public.blob.vercel-storage.com/drone%20%283%29.glb';
export interface HomeProps {
  emotion: 'auto' | 'neutral' | 'curious' | 'happy' | 'angry' | 'sad' | 'sleepy' | 'surprised';
  screenScale: number;
  faceSide: 'auto' | 'front' | 'back' | 'left' | 'right' | 'top';
  armsMode: 'auto' | 'open' | 'closed';
}
export function Home({
  emotion,
  screenScale,
  faceSide,
  armsMode
}: HomeProps) {
  const heroRef = useRef<HTMLElement>(null);
  const manifestoLineRef = useRef<HTMLParagraphElement>(null);
  const droneSlotRef = useRef<HTMLDivElement>(null);
  const manifestoHeadingRef = useRef<HTMLHeadingElement>(null);
  const projectGridRef = useRef<HTMLDivElement>(null);
  const finaleSlotRef = useRef<HTMLDivElement>(null);
  const statementRef = useRef<HTMLHeadingElement>(null);
  const footerSlotRef = useRef<HTMLDivElement>(null);
  return <main className="w-full bg-white font-sans text-black" data-id="element-229" data-mp="239ss24lminh4">
      <HeroSection sectionRef={heroRef} data-id="element-230" data-mp="1z7fwg90lc5y2" />
      <ShowreelVideo data-id="element-231" data-mp="1z6ea38e4jx11" />
      {/* Scroll-linked black that rises after the headline — sits under the sections below */}
      <DarkSweep triggerRef={manifestoHeadingRef} endRef={projectGridRef} accentTriggerRef={statementRef} data-id="element-232" data-mp="1u8utw2xv9a6g" />
      <ManifestoSection lineRef={manifestoLineRef} slotRef={droneSlotRef} headingRef={manifestoHeadingRef} data-id="element-233" data-mp="1kjfi9cbcv0ls" />
      <AgencyTagline data-id="element-234" data-mp="1ok7sa7s1x9j4" />
      <StatementSection headingRef={statementRef} data-id="element-235" data-mp="1amjax9x70kit" />
      <ProjectsSection gridRef={projectGridRef} data-id="element-236" data-mp="1ao434sw1brdi" />
      <OneMoreThing slotRef={finaleSlotRef} data-id="element-237" data-mp="1fle1iy1ejddh" />
      <WorkFlash data-id="element-238" data-mp="1fmfg3chmmhzy" />
      <ClosingHero slotRef={footerSlotRef} data-id="element-239" data-mp="1flw38a6u2jss" />
      <DroneCompanion heroRef={heroRef} slotRef={droneSlotRef} triggerRef={manifestoLineRef} finaleSlotRef={finaleSlotRef} footerSlotRef={footerSlotRef} modelUrl={MODEL_URL} emotion={emotion} screenScale={screenScale} faceSide={faceSide} armsMode={armsMode} data-id="element-240" data-mp="23aov9vkc47i4" />
      <GlassCrackOverlay data-id="element-241" data-mp="1yinm4iigqwwb" />
      <InteractionShield data-id="element-242" data-mp="1yi5k1594dogh" />
    </main>;
}